import { render, staticRenderFns } from "./SUPAOrganism.vue?vue&type=template&id=50ccd6b7&scoped=true&"
import script from "./SUPAOrganism.vue?vue&type=script&lang=ts&"
export * from "./SUPAOrganism.vue?vue&type=script&lang=ts&"
import style0 from "./SUPAOrganism.vue?vue&type=style&index=0&id=50ccd6b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ccd6b7",
  null
  
)

export default component.exports